import React from 'react';
import {Card} from 'reactstrap';
import ArrowSmall from "./../../icons/arrowSmall";

const handleButtonClick=(link)=>{
    if (window.eventDispatcher) {
		window.eventDispatcher.dispatchEvent('main-cta-click', {}, {amplitude: true});
	}
    window.location.href = link;
    
};

const CtaPanel = ({heading, subheading, mainCTAText, mainCTALink, isEven, secondaryCTAText,secondaryCTALink, imgDesktop, imgMobile, desktopTextColor, mobileTextColor, backgroundColor, lowerText, maxHeight}) => (
                <Card style={{marginBottom:'2px',borderRadius:'0'}}>

                {/* For Mobile */}
                <div
                    className="daan-utsav-main-wrapper-mobile"
                 >
                    <div className="daan-utsav-text-mobile">
                        <p className="daan-utsav-title-mobile">{heading}</p>
                        <p className="daan-utsav-sub-title-mobile">{subheading}</p>
                        <div className="daan-utsav-action-btn-link-mobile">
                            {mainCTAText && mainCTAText.length > 0 &&  <button onClick={() => handleButtonClick(mainCTALink)} className="daan-utsav-action-btn-mobile">{mainCTAText}</button>}

                            {secondaryCTAText && secondaryCTAText.length > 0 &&
                             <a className='daan-utsav-action-link-mobile' href={secondaryCTALink} onClick={() => {
                                if (window.eventDispatcher) {
                                    window.eventDispatcher.dispatchEvent('secondary-cta-click', {}, {amplitude: true});
                                }
                            }} >{secondaryCTAText}
                                <ArrowSmall color={mobileTextColor} style={{display: "inline-block", transform: "rotate(90deg)"}} size="16" className="daan-utsav-icon"/>
                              </a>
                            }

                        </div>
                   </div>
                   <div className="w-100">
                         <img src={`${imgMobile}`} className="img-fluid"/>
                    </div>

                </div>

                {/* For Desktop */}
                <div
                    className={`${isEven ? "alignment":""}  daan-utsav-main-wrapper-desktop background-image`}
                 >
                    <div className={`${isEven ? "alignment":""} daan-utsav-text`}>
                        <p className="daan-utsav-title">{heading}</p>
                        <p className="daan-utsav-sub-title">{subheading}</p>
                        <div className="daan-utsav-action-btn-link">
                            {mainCTAText && mainCTAText.length > 0 &&  <button onClick={() => handleButtonClick(mainCTALink)} className="daan-utsav-action-btn-mobile">{mainCTAText}</button>}

                            {secondaryCTAText && secondaryCTAText.length > 0 &&
                            <a className={`daan-utsav-action-link ${isEven ? "alignment":""}`} href={secondaryCTALink} onClick={() => {
                                if (window.eventDispatcher) {
                                    window.eventDispatcher.dispatchEvent('secondary-cta-click', {}, {amplitude: true});
                                }
                            }}>{secondaryCTAText}
                                <ArrowSmall color={desktopTextColor} style={{display: "inline-block", transform: "rotate(90deg)"}} size="16" className="daan-utsav-icon"/>
                              </a>
                            }

                        </div>
                   </div>

                </div>
                   <style jsx>
                        {
                            `
                          
                            .daan-utsav-title-mobile, .daan-utsav-sub-title-mobile, .daan-utsav-action-link-mobile, .daan-utsav-title, .daan-utsav-sub-title, .daan-utsav-action-link {
                            color:  ${mobileTextColor}
                            }
                            @media(min-width: 768px) {
                            .daan-utsav-title, .daan-utsav-sub-title, .daan-utsav-action-link {
                            color:  ${desktopTextColor}
                            }
                            }
                            // STYLING  DESKTOP VERSION
                            .daan-utsav-main-wrapper-desktop{
                                display:flex;
                                flex-direction:column;
                                justify-content:${lowerText? 'flex-end':'space-around'};
                                align-items:flex-end;
                                background-image: url(${imgDesktop});
                                background-size:cover;
                                background-position:${isEven ? 'center right' : 'center left'};
                            }

                            // *************** Mobile Screen | Mobile Wrapper has to be hidden on Large screens ******
                            
                            .daan-utsav-main-wrapper-mobile{
                                display:none;
                            }
                            
                            
                            // Large Devices CSS continues 
                            
                            .daan-utsav-main-wrapper-desktop.alignment{
                                justify-content:${lowerText? 'flex-end':'space-around'};
                                align-items:flex-start;
                            }
                            .background-image{
                                max-width:100%;
                                min-height:${maxHeight || '325px'};
                                background-repeat:no-repeat;
                                padding:3rem;
                            }

                            // TEXT STYLING

                            .daan-utsav-text{
                                width:50%;
                                color:#000;
                                font-weight:900;
                            }
                            .daan-utsav-title {
                            font-weight: 700;
                            }
                            .daan-utsav-sub-title {
                            font-weight: 400;
                            }
                            
                            .daan-utsav-text.alignment{
                                color:#fff;
                            }

                            .daan-utsav-text .daan-utsav-title{
                                font-size:24px;
                            }
                            
                            .daan-utsav-action-btn-link span{
                                padding-top:2px;
                            }
                            
                            .daan-utsav-action-btn{
                                padding:0.5rem 3.5rem !important;
                                background:#f66f6f !important;
                                border:none !important;
                                border-radius:5px;
                                color:#fff;
                                margin-right:2rem;
                                transition:all 0.3s ease-in;
                            }
                            .daan-utsav-action-btn-mobile:hover{
                                background:#ff5a5a !important;
                                cursor:pointer;
                                border:none !important;
                            }

                            .daan-utsav-action-link{
                                text-decoration:none !important;
                                border-bottom:2px solid;
                                padding-bottom:5px;
                                cursor: pointer;
                            }
                            
                            .daan-utsav-icon{
                                transform:rotate(45deg);
                            }

                            //  ******************** MOBILE VIEW DESIGN | CHANGE  ************************** //
                            @media (max-width:767px){
                                .daan-utsav-main-wrapper-mobile{
                                    display:flex;
                                    flex-direction:column;
                                    padding-top:3rem;
                                    background: ${backgroundColor}
                                }

                                // Desktop Div to be hidden on mobile devices

                                .daan-utsav-main-wrapper-desktop{
                                    display:none;
                                }

                                // Continue css styling for mobile
                                .daan-utsav-text-mobile{
                                    width:90%;
                                    align-self:center;
                                    text-align:center;
                                    background:solid;
                                }

                                 .daan-utsav-text-mobile .daan-utsav-title-mobile{
                                    font-size:24px;
                                    font-weight:900;
                                }
                                 .daan-utsav-text-mobile .daan-utsav-sub-title-mobile{
                                     font-size:18px;
                                     font-weight:500;
                                 }
                                .daan-utsav-action-btn-link-mobile{
                                    display:flex;
                                    flex-direction:column;
                                    align-items:center;
                                }

                                .daan-utsav-action-btn-mobile{
                                    width:80%;
                                    padding:1rem 0;
                                    background:#ff5a5a;
                                    border:none !important;
                                    border-radius:5px;
                                    color:#fff;
                                    transition:all 0.3s ease-in;
                                    margin-bottom:1rem;
                                    font-weight:700;
                                    cursor: pointer;
                                }

                                .daan-utsav-action-btn-mobile:hover{
                                    background:#fe3000 !important;
                                    cursor:pointer;
                                }

                                .daan-utsav-action-link-mobile{
                                    color: #444;
                                    border-bottom:1px solid;
                                    text-decoration:none !important;
                                    transition:all 0.3s ease-in;
                                    cursor: pointer;
                                }
                            }
                            @media (min-width:768px){
                            .daan-utsav-action-btn-mobile{
                                    min-width:200px;
                                    padding:1rem 0;
                                    background:#ff5a5a;
                                    border:none !important;
                                    border-radius:5px;
                                    color:#fff;
                                    transition:all 0.3s ease-in;
                                    margin-bottom:1rem;
                                    font-weight:700;
                                    margin-right: 2rem;
                                    cursor: pointer;
                                }
                                }
                            `
                        }
                    </style>

                </Card>);


export default CtaPanel;
